import { gql } from "@apollo/client";
import { TEAM_COLORS } from "helpers/colors";
import React from "react";

import PlayerAvatar from "../atoms/PlayerAvatar";

export const ReelViewAvatarFragment = gql`
  fragment ReelViewAvatarFragment on ReelView {
    isPlayerReel
    playerNumber
    teamColor
  }
`;

export default function ReelViewAvatar({ reelView, ...others }) {
  return (
    reelView?.isPlayerReel && (
      <PlayerAvatar playerNumber={reelView.playerNumber} color={TEAM_COLORS[reelView.teamColor]} {...others} />
    )
  );
}
